import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshidx
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";
import ReactPlayer from 'react-player';

import CreditCardForm from "./CreditCardForm.js";

import ImageGallery from "react-image-gallery";
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import ReCAPTCHA from "react-google-recaptcha";
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import axios from "axios";

//import React from 'react';
//import ImageGallery from 'react-image-gallery';

const VideoSlide = () => (
    <div className="video-wrapper">
      <video controls width="50%" poster="/static/images/IMG_7191.png">
        <source src="/static/images/file_example_MP4_1280_10MG.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
);

const VideoSlide1 = () => (
    <div className="video-wrapper">
      <video controls width="60%" height="30%" poster="/static/images/DSC08313.JPG">
        <source src="/static/images/OrchimaWatering.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
);

const VideoSlide2 = () => (
    <div className="video-wrapper">
      <video controls width="60%" height="30%" poster="/static/images/OrchimaWaterReleasepng.png">
        <source src="/static/images/OrchimaWaterRelease.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
);
/*
const items = [
  {
    original: '/image1.jpg',
    thumbnail: '/thumb1.jpg',
  },
  {
    renderItem: () => <VideoSlide />,
    thumbnail: '/video-thumbnail.jpg',
  },
  {
    original: '/image2.jpg',
    thumbnail: '/thumb2.jpg',
  }
];

export default function App() {
  return <ImageGallery items={items} />;
}

 */


/*const images = [
  {
    original: "https://picsum.photos/id/1018/1000/600/",
    thumbnail: "https://picsum.photos/id/1018/250/150/",
  },
  {
    original: "https://picsum.photos/id/1015/1000/600/",
    thumbnail: "https://picsum.photos/id/1015/250/150/",
  },
  {
    original: "https://picsum.photos/id/1019/1000/600/",
    thumbnail: "https://picsum.photos/id/1019/250/150/",
  },
];*/




const images = [
  /*{
    original: "/static/images/DSC08295.JPG",
    thumbnail: "/static/images/DSC08295.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Orchima Pot",
    thumbnailTitle:"Orchima Pot",
    thumbnailLabel:"Orchima Pot",
    description:"Description 1"
  },*/
  /*{
    original: "/static/images/DSC08300.JPG",
    thumbnail: "/static/images/DSC08300.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Some title",
    thumbnailTitle:"Some nails",
    thumbnailLabel:"Label 2",
    description:"Description 2"
  },*/
  /*{
    original: "/static/images/DSC08313.JPG",
    thumbnail: "/static/images/DSC08313.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Some title",
    thumbnailTitle:"Some nails",
    thumbnailLabel:"Label 3",
    description:"Description 3"

  },
  {
    original: "/static/images/DSC08292.JPG",
    thumbnail: "/static/images/DSC08292.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Some title",
    thumbnailTitle:"Some nails",
    thumbnailLabel:"Label 4A",
    description:"Description 4"
  },*/
  /*{
    original: "/static/images/DSC08276.JPG",
    thumbnail: "/static/images/DSC08276.JPG",
    originalHeight:"600",
    originalWidth:"600",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Orchima Pot bottom",
    thumbnailTitle:"Orchima Pot bottom",
    thumbnailLabel:"Orchima Pot bottom",
    description:"Orchima Pot bottom"
  },*/
  {
    //original: "/static/images/file_example_MP4_1280_10MG.mp4",
    renderItem: () => <VideoSlide1 />,
    thumbnail: "/static/images/DSC08313.JPG",
    originalHeight:"200",
    originalWidth:"200",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Watering Orchima Pot",
    thumbnailTitle:"Watering Orchima Pot",
    thumbnailLabel:"Watering Orchima Pot",
    description:"Watering Orchima Pot"
  },
  {
    //original: "/static/images/file_example_MP4_1280_10MG.mp4",
    renderItem: () => <VideoSlide2 />,
    thumbnail: "/static/images/OrchimaWaterReleasepng.png",
    originalHeight:"200",
    originalWidth:"200",
    thumbnailHeight:100,
    thumbnailWidth:100,
    originalTitle:"Releasing water",
    thumbnailTitle:"Releasing water",
    thumbnailLabel:"Releasing water",
    description:"Releasing Water"
  },
];



//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },

  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});


class AboutFloraPot extends Component {

  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{},
    selectedUser:{},
    showOrderForm:false,
    showOrderDialog: false,
    captchaValue:"",
    potPrice:3.50,

  };

  constructor(props) {
    super(props);

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);

    this.handleAddress2Change = this.handleAddress2Change.bind(this);
    this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);
    this.handleClickShowOrderDialog = this.handleClickShowOrderDialog.bind(this);
    this.handleClickShowOrderDialogClose = this.handleClickShowOrderDialogClose.bind(this);
    this.handleCaptchaChange= this.handleCaptchaChange.bind(this);
    this.recaptchaRef = React.createRef();


  }


  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    //isAuthenticated();
    //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
    //updateUserProfileAction(null, this.props.loginData.accessToken);
    //this.getPotPriceFromServer(DEFAULT_VESPAAN_SERVER.url);
    //updateAuth();
    // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;

  }


  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleShowOrderFormChange = event => {
    //this.setState({ showOrderForm:!this.state.showOrderForm });
    //this.getPotPriceFromServer(DEFAULT_VESPAAN_SERVER.url);
    this.setState({ showOrderDialog:true });

  };

  handleFirstNameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));

    //this.setState({userComment , {{firstname:event.target.value }});
    // this.setState(Object.assign(this.state.firstname, event.target.value));
  }

  handleLastNameChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.lastname, event.target.value));
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));

  }

  handleEmailChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.email,event.target.value));
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));

  }
  handleCommentChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }

  handleClickShowOrderDialog(){
    this.setState({ showOrderDialog: true });
  };


  handleClickShowOrderDialogClose(){
    //let { clearCardErrorMsg } = this.props;
    this.setState({ showOrderDialog: false });
    //clearCardErrorMsg();
  };

  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;


    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {

      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {

        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {

          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              //Here send the data to the back end.
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);

            }
          }
        }
      }
    }

    return returnString;
  }

//Background color was backgroundColor:'#f4f3ed',

  handleAddress2Change(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
  }


  handleCaptchaChange = (value) => {
    this.setState({ captchaValue: value });
  };



  render() {
    let shorOrderFormButtonText="";
    const { classes } = this.props;
    const MyLink = props => <RouterLink to="#top2" {...props} />
    if( !this.state.showOrderForm){
      shorOrderFormButtonText = "Place a Purchase Order";
    }else{
      shorOrderFormButtonText = "Hide Order Form";
    }
    return (

        <div id="top1"  style={{  }}>
          <Grid container spacing={24}>

            <Grid   item xs={12} sm={12}  >


              <div    style = { {  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat'  }}>


                {/*<Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , marginTop:10,  color:'#BF360C', fontSize:30}}>
                About {MainConstants.APPLICATION_NAME}&trade;
              </Typography>*/}

                {/*<h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>*/}

                {/*}
              <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      {MainConstants.APPLICATION_NAME}&trade; is thoughtfully designed specifically for orchids.
                      It allows you to soak the roots and bark by filling the side reservoir, and after 10 to 15 minutes,
                      you can easily drain the water using the built-in release valve at the base.

                      This eliminates the risk of damaging your orchid, as there’s no need to tilt the pot or remove an inner liner to pour out excess water. The drainage process is clean, efficient, and minimizes splashing — keeping both your plant and surrounding space protected.</Typography>


                    <br/>


                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
              </div> */}


                {/*
              <Grid item  xs={12} sm={12}  md={3} lg={3}   xl={3} >
                <TextField id="address2"   style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:'lightblue', fontSize:26, marginLeft:20}} name="Name" label="Name" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.address2} onChange={this.handleAddress2Change} />
              </Grid>
              <Grid item  xs={12} sm={12}  md={3} lg={3}   xl={3} >
                <TextField id="address2"   style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:'lightsteelblue', fontSize:26, marginLeft:20}} name="Number" label="Card Number" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.address2} onChange={this.handleAddress2Change} />
              </Grid>
              <Grid item  xs={12} sm={12}  md={3} lg={3}   xl={3} >
                <TextField id="address2"   style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:'lightgoldenrodyellow', fontSize:26, marginLeft:20}} name="Name" label="Name" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.address2} onChange={this.handleAddress2Change} />
              </Grid>
              <Grid item  xs={12} sm={12}  md={3} lg={3}   xl={3} >
                <TextField id="address2"   style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:'lightgrey', fontSize:26, marginLeft:20}} name="Name" label="Name" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.address2} onChange={this.handleAddress2Change} />
              </Grid>
              <Grid item  xs={12} sm={12}  md={3} lg={3}   xl={3} >
                <TextField id="address2"   style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:'lightskyblue', fontSize:26, marginLeft:20}} name="Name" label="Name" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.address2} onChange={this.handleAddress2Change} />
              </Grid><Grid item  xs={12} sm={12}  md={3} lg={3}   xl={3} >
              <TextField id="address2"   style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:'lightseagreen', fontSize:26, marginLeft:20}} name="Name" label="Name" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.address2} onChange={this.handleAddress2Change} />
            </Grid>
              */}
                <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                  Designed for beauty, Engineered for ease, Loved by orchids
                </Typography>
                <br/>

                <Typography variant="h5" component="h2" style = { {  marginTop:15, textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                  {/*<Text>How do you feel when your vehicle is being towed for a parking violation? </Text>*/}
                  How many orchids have wilted in your care — and you never knew why?
                </Typography>




                <br/>


                {/*<h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>*/}

                <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>

                  <Grid container spacing={24}>
                    <Grid   item xs={1} sm={1}  >
                    </Grid>
                    <Grid   item xs={10} sm={10}  >
                      <div style={{paddingLeft:10, paddingBottom:10, paddingTop:20, display: 'flex', flexDirection: 'column', justifyContent: 'left' }}>
                      {/*<Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      {MainConstants.APPLICATION_NAME}&trade; pot is patent pending technology that is thoughtfully designed for orchids, offering a simple, gentle way to water and care for them.
                      Once a week, just fill the reservoir to soak the roots and bark, then, after 10–30 minutes, release the built-in drainage
                      valve at the base to let the water out. This smart design removes the need to tip the pot or lift out an inner liner,
                      reducing the risk of damaging your orchid. The process is clean, splash-free, and keeps both your plant and its
                      surroundings safe.
                      For added root health, you can leave the drainage valve open to allow continuous airflow. Kindly note that this process is applicable exclusively to bark-based mixes and is not suitable for sphagnum moss..
                      </Typography>*/}
                      {/*<Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                        Meet our patent-pending  {MainConstants.APPLICATION_NAME}&trade; pot — thoughtfully designed to make orchid care easier than ever.
                        Just once a week, fill the built-in reservoir with water or a mix of water and orchid plant food to gently soak the roots and bark. After 10–30 minutes, open the drainage valve at the base and let the water flow out. This smart design removes the need to tip the pot or lift out an inner liner,
                        reducing the risk of damaging your orchid. No tipping, no mess, no heavy lifting — just healthy, happy orchids.
                        This clean, splash-free system protects both your plant and your home. And for an extra boost of root health, simply leave the drainage valve open to encourage continuous airflow.
                      </Typography>*/}
                        {/* Jan_2026<Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          Meet our patent-pending  {MainConstants.APPLICATION_NAME}&trade; pot — Every element of Orchima™ is thoughtfully designed for the world’s most refined blooms.
                          From its seamless reservoir to its elegantly engineered drainage system, it delivers care with the
                          sophistication and attention your orchids truly deserve.
                        </Typography> */}

                        <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          {MainConstants.APPLICATION_NAME}&trade; is a patent-pending orchid pot created to take the guesswork out of orchid care. Thoughtfully
                          engineered with a built-in reservoir and an elegant drainage system, Orchima™ provides the ideal
                          balance of moisture, airflow, and protection—so your orchids thrive with minimal effort.
                        </Typography>
                        <br/>
                        {/* Jan_2026 <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>

                        Once a week, fill the reservoir, allow the roots and barks to soak, then open the drain to release the water.
                        This smart design removes the need to tip the pot or lift out an inner liner,
                        reducing the risk of damaging your orchid. No tipping, no mess, no heavy lifting — just healthy, happy orchids.

                      </Typography>*/}
                        <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>

                          When watering is needed, simply fill the reservoir and allow the roots and bark to soak. When finished, open the drainage valve
                          to release excess water—no tipping, no lifting, and no mess.
                          The pot can also be left open after draining to promote continuous airflow and healthier roots.
                        </Typography>
                        <br/>
                        {/* Jan_2026<Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          This clean, splash-free system protects both your plant and your home. And for an extra boost of root health, simply leave the drainage valve
                          open to encourage continuous airflow.
                        </Typography> */}
                        <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          Unlike traditional soaking methods that use shared containers and risk spreading disease, {MainConstants.APPLICATION_NAME}&trade; gives each orchid its own dedicated
                          home, helping prevent cross-contamination and creating a cleaner, safer growing environment.
                        </Typography>
                         <br/>
                        {/*<Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'left', paddingBottom:'200', marginBottom:'100', width:'300'}}>

                        Designed for bark-based orchid mixes and sphagnum moss.
                      </Typography>*/}
                        <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'left', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                          Designed for bark-based orchid mixes and sphagnum moss, {MainConstants.APPLICATION_NAME}&trade; protects both your plant and your space while making orchid
                          care easy and enjoyable for beginners and enthusiasts alike.
                        </Typography>
                      </div>
                      <br/>
                      <ul style = { { fontSize:18, color:'black', marginLeft:20 }}>
                        <div>
                          <div style = { {  textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ }}>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  ,fontSize:24,  color:'#BF360C',}}>
                                Features & Benefits
                              </Typography>
                            </div>
                          </div>

                        </div>

                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Built-in reservoir for easy soak-and-drain watering
                            </Typography>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Bottom drainage valve—no tipping or heavy lifting
                            </Typography>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Promotes healthy roots with optional continuous airflow
                            </Typography>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Helps prevent disease spread between plants
                            </Typography>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Clean, splash-free design for indoor use
                            </Typography>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Includes pot, liner, and screen filter
                            </Typography>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'left', alignSelf: 'left', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                        {MainConstants.APPLICATION_NAME}&trade; makes growing orchids simpler, safer, and more rewarding—helping more people enjoy orchids and grow with confidence.
                      </Typography>



                      {/* Jan_2026<Typography variant="h6" component="h6" style = { {paddingLeft:10,textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>

                        Many orchid enthusiasts soak several plants in the same big container, but this can easily spread
                        diseases from one orchid to another. With {MainConstants.APPLICATION_NAME}&trade; pots, every orchid enjoys its own dedicated home.
                        This not only prevents cross-contamination but also
                        ensures a healthier, safer growing environment for each plant.</Typography>*/}

                      <br/>
                      <Typography variant="h6" component="h2" style = { {paddingLeft:10,textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                        The aspiration behind the {MainConstants.APPLICATION_NAME}&trade; pot is to make orchid care accessible to more people, encouraging beginners to enjoy growing orchids, become enthusiasts, and
                        help expand the community of orchid lovers in the U.S. and around the world.
                      </Typography>



                      <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'column', display: 'flex', }}>
                        <div  style={{ flex: 1 }}>
                          <Typography variant="h5" component="h2" style = { {  marginTop:15, textAlign: 'center', alignSelf: 'center'  ,  color:'#BF360C', fontSize:28}}>
                            Fill, Soak, Drain
                          </Typography>
                          <Typography variant="h5" component="h2" style = { {  marginTop:15, textAlign: 'center', alignSelf: 'center'  ,  color:'#BF360C', fontSize:28}}>
                            The easiest way to care for orchids
                          </Typography>
                          <Typography variant="h5" component="h2" style = { {  marginTop:15, textAlign: 'center', alignSelf: 'center'  , color:'black', fontSize:18}}>
                            Click picture to a see a larger view
                          </Typography>
                        </div>
                        <div  style={{marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:300, alignSelf: 'center' ,  }}>
                          <Zoom>
                            <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/OrchimaPotPlant3.png"
                                aspectRatio='(3/4)'
                            />
                          </Zoom>
                        </div>

                      </div>


                      <br/>
                      <br/>

                    </Grid>
                    <Grid   item xs={1} sm={1}  >
                    </Grid>
                  </Grid>

                  <Grid container spacing={24}>
                    <Grid   item xs={1} sm={1}  >
                    </Grid>

                    {/*<Grid   item xs={12} sm={12}  md={7} lg={7}   xl={7} > */}

                    {/*<ImageGallery items={images}
                                     thumbnailTitle="TumbNails Titles"
                                     description={"description"}
                                     thumbnailPosition={'bottom'}
                                     showBullets={true}
                                     showIndex={true}
                                     showPlayButton={false}
                                     showNav={false}
                                     showFullscreenButton={false}/>
                      <br/>




                      <br/>*/}
                    {/* }
                    <div style={{paddingLeft:100, paddingBottom:10, paddingTop:20, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <div  style={{   marginLeft:10, marginTop:10 ,  marginBotton:10, height:200, width:200  }}>
                        <Image
                            //src="/static/images/IMG_3615.JPG"
                            src="/static/images/IMG_7193.png"
                            aspectRatio='(3/4)'
                        />
                      </div>
                      <div  style={{   marginLeft:10, marginTop:100 ,  marginBotton:10, marginBotton:10,   width:200  }}>
                        <Image
                            //src="/static/images/IMG_3615.JPG"
                            src="/static/images/IMG_7193.png"
                            aspectRatio='(3/4)'
                        />
                      </div>
                      <div  style={{   marginLeft:10, marginTop:10 ,  marginBotton:10, height:200, width:200  }}>
                        <Image
                            //src="/static/images/IMG_3615.JPG"
                            src="/static/images/IMG_7193.png"
                            aspectRatio='(3/4)'
                        />
                      </div>
                      <div  style={{   marginLeft:10, marginTop:100 ,  marginBotton:10, marginBotton:10,   width:200  }}>
                        <Image
                            //src="/static/images/IMG_3615.JPG"
                            src="/static/images/IMG_7193.png"
                            aspectRatio='(3/4)'
                        />
                      </div>

                    </div>
                    */}


                    {/*}</Grid> */}



                    <Grid   item xs={12} sm={12}   md={8} lg={8}   xl={8} >


                      {/*<Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                        {MainConstants.APPLICATION_NAME}&trade; Details
                      </Typography>
                      <Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'black', fontSize:20}}>
                        Every element of {MainConstants.APPLICATION_NAME}&trade; is thoughtfully designed for the world’s most refined blooms. From its seamless reservoir to its elegantly engineered drainage system, it delivers care with
                        the sophistication and attention your orchids truly deserve.   </Typography>
                      <br/>*/}
                      {/*}
                      <Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:20}}>
                        See the {MainConstants.APPLICATION_NAME}&trade; pot in action through the pictures and videos on the side.
                      </Typography>
                      <br/>

                      <ol>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          {MainConstants.APPLICATION_NAME}&trade; Front view of the pot.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          {MainConstants.APPLICATION_NAME}&trade; Bottom view of the pot with the release valve.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          With the bottom valve fully closed, fill the reservoir with water or a mix of water and plant food.</li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          Once the soaking period is complete, open the bottom valve to drain the water. Be
                          sure the pot is positioned over a sink while it empties.
                        </li>
                      </ol> */}
                      <Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:24}}>
                        {MainConstants.APPLICATION_NAME}&trade; Pot Feature Details
                      </Typography>
                      <br/>

                      <ol>

                        <div>
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}>

                            </div>
                            <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Click any picture to see a larger view.
                              </Typography>
                            </div>
                          </div>

                        </div>

                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Each {MainConstants.APPLICATION_NAME}&trade; pot purchase includes the pot, liner, and screen filter.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                              </Typography>
                            </div>
                            <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/Parts1.png"
                                    aspectRatio='(6/4)'
                                />
                              </Zoom>
                            </div>
                          </div>

                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              For easy drainage, the pot includes a valve at the bottom.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Open the valve to release any excess water. Once the pot is fully drained, the valve can be left open to allow airflow to the roots.
                              </Typography>
                              {/*<Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:14}}>
                                Please note that the pot is shown on its side in this picture to highlight the valve. In actual use, the pot should remain
                                upright and filled with water while you open the valve with your other hand.</Typography>*/}
                            </div>
                            <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotBottom2.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>
                          </div>

                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              The pot features a built-in edge that provides an easy grip, making it simple to lift and carry.
                            </Typography>
                              {/*<Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Make sure the Orchima pot is fully drained before removing it from the sink.
                              </Typography>*/}
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaEdge.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>

                          </div>

                        </li>
                      </ol>

                      <Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                        Sustainable Orchid care
                      </Typography>
                      <Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:20}}>
                         View the {MainConstants.APPLICATION_NAME}™ pot in action through the videos shown below
                      </Typography>
                      <br/>
                      <ol>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                            Take the {MainConstants.APPLICATION_NAME}&trade; Pot to a sink
                          </Typography>
                        </li>
                        <br/>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                            Fill it to the rim with water or mixture of water and Orchid fertilizer.
                          </Typography>
                          <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                            It is recommended that you alternate watering your orchid—once with plain water and the next time with a mixture of water and fertilizer. The frequency of watering depends on the
                            environment in which your orchid lives and the level of moisture in that environment.
                          </Typography>
                        </li>
                        <br/>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>
                          <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                            Let the bark or sphagnum moss soak for up to 15 minutes.
                          </Typography>
                          <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                            How long you keep your orchid fully submerged in water or in a water-and-fertilizer mixture also depends on how moist your environment is.
                          </Typography>
                        </li>
                        <br/>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', }}>

                          <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                            Open the bottom valve and allow all water to drain completely.
                          </Typography>
                          <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                            The drainage process may take a few minutes.
                          </Typography>
                        </li>
                        <br/>
                      </ol>
                       <ImageGallery items={images}
                                     thumbnailTitle="TumbNails Titles"
                                     description={"description"}
                                     thumbnailPosition={'bottom'}
                                     showBullets={true}
                                     showIndex={true}
                                     showPlayButton={false}
                                     showNav={false}
                                     showFullscreenButton={false}/>
                      <br/>
                      <br/>

                      <Typography  style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                        {MainConstants.APPLICATION_NAME}&trade; Instructions on how to plant your orchid.
                      </Typography>
                      <br/>

                      <ol>

                        <div>
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}>

                            </div>
                            <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Click any picture to see a larger view.
                              </Typography>
                            </div>
                          </div>

                        </div>

                        {/*<li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Each Orchima pot purchase includes the pot, liner, and screen filter.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                              </Typography>
                            </div>
                            <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/Parts1.png"
                                  aspectRatio='(6/4)'
                              />
                              </Zoom>
                            </div>
                          </div>

                        </li>*/}
                        {/*<li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              For easy drainage, the pot includes a valve at the bottom.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Open the valve to release any excess water. Once the pot is fully drained, the valve can be left open to allow airflow to the roots.
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:14}}>
                                Please note that the pot is shown on its side in this picture to highlight the valve. In actual use, the pot should remain
                                upright and filled with water while you open the valve with your other hand.</Typography>
                            </div>
                            <div  style={{ marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotBottom2.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>
                          </div>

                        </li>*/}
                        {/*<li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              The pot features a built-in edge that provides an easy grip, making it simple to lift and carry.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Make sure the Orchima pot is fully drained before removing it from the sink.
                              </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaEdge.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>

                          </div>

                        </li>*/}
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Add a few small stones to the bottom of the liner.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Add a few small stones to the bottom of the liner. This prevents the liner from floating once water is added to the {MainConstants.APPLICATION_NAME}&trade; Pot.
                              </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/LineWithStones.png"
                                  aspectRatio='(6/4)'
                              />
                              </Zoom>
                            </div>
                          </div>

                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Fill the liner with orchid bark.
                              </Typography>

                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/LinerWithBarks.png"
                                  aspectRatio='(6/4)'
                              />
                              </Zoom>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                                Thoroughly rinse the bark to remove all fine debris
                              </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Over time, fine particles can clog the drainage valve, requiring you to remove the liner and wash both the pot and the drainage valve.
                              </Typography>

                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/WashingDebris.png"
                                    aspectRatio='(6/4)'
                                />
                              </Zoom>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Place your orchid into the bark-filled liner.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                              </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/LinerWithPlant.png"
                                  aspectRatio='(4/6)'
                              />
                              </Zoom>
                            </div>
                          </div>

                        </li>
                        {/*}
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Take the liner (with the orchid inside) to a sink and rinse it thoroughly.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Run water through the bark until all fine particles and debris are washed away.
                              </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/Filter.JPG"
                                  aspectRatio='(6/4)'
                              />
                              </Zoom>
                            </div>
                          </div>

                        </li>*/}
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Put the round filter at the bottom of the pot.
                            </Typography>

                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/PotAndLiner.png"
                                  aspectRatio='(3/4)'
                              />
                              </Zoom>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Place the rinsed, planted liner into the {MainConstants.APPLICATION_NAME}&trade; Pot.
                            </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/placingLiner.png"
                                  aspectRatio='(3/4)'
                              />
                              </Zoom>

                            </div>
                            {/*<div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotPlant3.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>*/}
                          </div>

                        </li>
                        <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              Enjoy your {MainConstants.APPLICATION_NAME}&trade; Pot.
                            </Typography>
                            </div>
                            {/*<div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/placingLiner.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>

                            </div>*/}
                             <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotPlant3.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>
                          </div>

                        </li>
                        {/*<li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              For airflow and ventilation, you may leave the bottom valve open.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                               Make sure the Orchima pot is fully drained before removing it from the sink.
                              </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                              <Image
                                  //src="/static/images/IMG_3615.JPG"
                                  src="/static/images/OrchimaPotBottom2.png"
                                  aspectRatio='(3/4)'
                              />
                              </Zoom>
                            </div>
                          </div>

                        </li>*/}
                        {/*<li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              For airflow and ventilation, you may leave the bottom valve open.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Make sure the Orchima pot is fully drained before removing it from the sink.
                              </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotPlant3.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>
                          </div>

                        </li>*/}
                        {/*<li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              For airflow and ventilation, you may leave the bottom valve open.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Make sure the Orchima pot is fully drained before removing it from the sink.
                              </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotBottom2.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotBottom.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>
                          </div>

                        </li>*/}
                        {/*<li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              For airflow and ventilation, you may leave the bottom valve open.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Make sure the Orchima pot is fully drained before removing it from the sink.
                              </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotBottom2.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPotBottom.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>
                          </div>
                        </li>*/}
                        {/*} <li >
                          <div style = { {  marginTop:10, textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', flexDirection:'row', display: 'flex', }}>
                            <div  style={{ flex: 1 }}><Typography  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black', fontSize:18}}>
                              For airflow and ventilation, you may leave the bottom valve open.
                            </Typography>
                              <Typography  style = { { textAlign: 'left', alignSelf: 'left', fontStyle:'italic'  , color:'black', fontSize:16}}>
                                Make sure the Orchima pot is fully drained before removing it from the sink.
                              </Typography>
                            </div>
                            <div  style={{   marginLeft:10, marginTop:5,  marginBotton:10,  marginRight:10,  width:200  }}>
                              <Zoom>
                                <Image
                                    //src="/static/images/IMG_3615.JPG"
                                    src="/static/images/OrchimaPot1.png"
                                    aspectRatio='(3/4)'
                                />
                              </Zoom>
                            </div>

                          </div>

                        </li>*/}

                      </ol>

                    </Grid>





                    <Grid   item xs={12} sm={12}   md={0} lg={0}   xl={0} >
                    </Grid>




                    <Grid item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                    </Grid>

                  </Grid>

                  <Grid container spacing={24}>
                    <Grid item xs={12} sm={12}  md={3} lg={3}   xl={3}  >
                    </Grid>
                    <Grid   item xs={12} sm={12}  md={6} lg={6}   xl={6}  >
                      {/*<Button variant="contained" color="primary" onClick={this.handleShowOrderFormChange} style = { { border: '3px solid', borderSize:5, borderColor:'black',textAlign: 'center', alignSelf: 'center'  , backgroundColor:'#1a736a', fontSize:22, marginLeft:10, width:'100%'}} className={classes.button}>{shorOrderFormButtonText}
                    </Button>*/}
                      <div   style = { { border: '3px solid', borderSize:5, borderColor:'#1a736a',textAlign: 'center', alignSelf: 'center'  ,   fontSize:22,   textTransform: "unset !important", padding:30}}>
                        <form onSubmit={this.handleShowOrderFormChange}>

                          <ReCAPTCHA

                              sitekey={MainConstants.RECAPTCHASITEKEY }
                              size="normal" // Use "invisible" for reCAPTCHA v3 or "normal" for v2
                              ref={this.recaptchaRef}
                              onChange={this.handleCaptchaChange}
                              badge="bottomright" // Adjust badge position as needed
                              style = {{  display:'flex', marginBottom:1, marginTop:2, justifyContent:'center',  alignItems: 'center', }}  />
                          {/*<Button size="large"  type="submit" variant="contained"   style = { { backgroundColor:'#D4E0EA',fontSize:20, color:'black' ,border: '2px solid', borderSize:5,   borderRadius:5, bordered:'true', borderColor:'black', textTransform:'none', width:'50%'}} >Submit</Button> */}
                          <Button variant="contained" color="primary" onClick={this.handleShowOrderFormChange} style = { { border: '3px solid', borderSize:5, borderColor:'black',textAlign: 'center', alignSelf: 'center'  , backgroundColor:'#1a736a', fontSize:22, marginLeft:0, width:'100%', textTransform: "unset !important",}} className={classes.button}>{shorOrderFormButtonText}
                          </Button>
                        </form>

                        {/*
                                                                                              <Button size="large"  variant="contained"   style = { { backgroundColor:'#D4E0EA',fontSize:20, color:'black' ,border: '2px solid', borderSize:5,   borderRadius:5, bordered:'true', borderColor:'black'}} onClick={this.saveVisitorComment} >Submit</Button>
                                                                                                */}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12}  md={3} lg={3}   xl={3}  >
                    </Grid>
                  </Grid>



                  {/*{(this.state.showOrderForm) &&(
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <CreditCardForm></CreditCardForm>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>)} */}

                </div>



                {/*}
              <div style = { {textAlign: 'center', alignSelf: 'center', paddingTop:'200', marginBottom:'100',  marginTop:'200', width:'100%'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item   xs={12} sm={12}  md={5} lg={5}   xl={5}  >


                    <br/>

                    <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                      Steps to Clean and Reassemble the {MainConstants.APPLICATION_NAME}&trade; Valve
                    </Typography >
                    <Typography  style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                    Sometimes small particles can become lodged in the valve, preventing it from closing tightly. This can cause the valve to leak and stop the bark from soaking properly.
                    To fix this issue, please follow the steps below:
                    </Typography>

                    <ol>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                        Place the pot in an area where it can be safely drained.
                      </li>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                        Remove the valve from the bottom of the {MainConstants.APPLICATION_NAME}&trade;.
                      </li>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                        Disassemble the valve by twisting it until the cover comes off.
                      </li>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                        Inspect both pieces (as shown in the picture), wash them thoroughly, and ensure there is no debris inside the valve.
                      </li>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                        Reassemble the valve by screwing the cap back onto the main valve body.
                      </li>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                        Reattach the valve to the bottom of the pot.
                      </li>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                        Your {MainConstants.APPLICATION_NAME}&trade; is now ready for use again.
                      </li>
                    </ol>



                  </Grid>
                  <Grid   item xs={12} sm={12}  md={5} lg={5}   xl={5}  style={{ marginRight:30, marginLeft:10, marginTop:10 ,  marginBotton:10, height:'20%'}} >

                        <div style={{paddingLeft:100, paddingBottom:10, paddingTop:20, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <div  style={{   marginLeft:10, marginTop:10 ,  marginBotton:10, height:200, width:200  }}>
                            <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/IMG_7193.png"
                                aspectRatio='(3/4)'
                            />
                          </div>
                          <div  style={{   marginLeft:10, marginTop:100 ,  marginBotton:10, marginBotton:10,   width:200  }}>
                            <Image
                                //src="/static/images/IMG_3615.JPG"
                                src="/static/images/IMG_7193.png"
                                aspectRatio='(3/4)'
                            />
                          </div>
                        </div>

                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
              </div>

              */}
                <br/>
                <Grid container spacing={24} >
                  <Grid   item xs={1} sm={1}  >
                  </Grid>

                  <Grid   item xs={9} sm={9}    md={9} lg={9}   xl={9} >
                    <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', marginTop:'300', width:'400', fontSize:'36'}}>
                      <Typography variant="h6" component="h2" style = { { textAlign: 'left', alignSelf: 'center'  , color:'#BF360C', fontSize:26}}>
                        The Significance of  the word {MainConstants.APPLICATION_NAME}&trade;
                      </Typography>
                      <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 }}>
                        {MainConstants.APPLICATION_NAME}&trade; is born from the union of two words: Orchid and Anima.
                        Anima—the soul—gives the name its essence. Together, Orchima means “the soul of the orchid,” capturing the delicate beauty, spirit, and life that orchids symbolize.

                        It’s more than just a name—it reflects harmony, elegance, and the timeless connection between nature and soul. </Typography>
                    </div>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
                <br/>
                <br/>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>

                  <Grid   item xs={9} sm={9}  >

                    <div>
                      <div  style={{ marginRight:60, marginLeft:10, marginTop:10,  marginBotton:10  }}>
                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , fontWeight:600 ,color:'#BF360C', }}>
                          {MainConstants.APPLICATION_NAME}&trade; Valve Cleanup: </Typography>

                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , }}>
                          Steps to Clean and reattach the {MainConstants.APPLICATION_NAME}&trade; Valve, please follow this link <a href="/orchimacleanup"   rel="noreferrer">Orchima Valve Cleanup</a>.</Typography>
                      </div>
                    </div>
                    <div>
                      <div  style={{ marginRight:60, marginLeft:10, marginTop:10,  marginBotton:10  }}>
                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , fontWeight:600 ,color:'#BF360C', }}>
                          Education: </Typography>

                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , }}>
                          For more educational content about orchids, please follow this link <a href="/orchideducation"   rel="noreferrer">Orchid Education</a>.</Typography>
                      </div>
                    </div>


                    <div>
                      <div  style={{   marginLeft:10, marginTop:10,  marginBotton:10  }}>
                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 ,color:'#BF360C', fontWeight:600 }}>
                          Orchid Challenges: </Typography>
                        <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 }}>
                          Orchids can be incredibly rewarding to grow, but they don’t behave like most houseplants.
                          Many growers face similar challenges.
                          To learn about common orchid health issues and how to spot them,
                          please follow this link. <a href="/orchidproblems"   rel="noreferrer">
                          Orchid Challenges</a>
                        </Typography>
                      </div>
                      <div>
                        <div  style={{ marginRight:60, marginLeft:10, marginTop:10,  marginBotton:10  }}>
                          <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , fontWeight:600 ,color:'#BF360C', }}>
                            Disclaimer: </Typography>

                          <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , }}>
                            For product disclaimer, please follow this link <a href="/disclaimer"   rel="noreferrer">Product Disclaimer</a>.</Typography>
                        </div>
                      </div>

                      <div>
                        <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10  }}>
                          <Typography component="h2" variant="body1"  style = { {textAlign: 'center', alignSelf: 'center', fontSize:24 , fontWeight:600 ,color:'#BF360C', }}>
                            Orchid Organizations </Typography>
                          <ol type="A">
                            <li>
                          <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 , marginBottom:15, }}>
                             <a href="https://www.aos.org/"   rel="noreferrer">American Orchid Society</a></Typography>
                            </li>
                            <li>
                              <Typography component="h2" variant="body1"  style = { {textAlign: 'left', alignSelf: 'center', fontSize:18 ,marginBottom:15, }}>
                            <a href="https://www.orchidconservationcoalition.org/"   rel="noreferrer">Orchid Conservation Coalition</a></Typography>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>


                <br/>

                {/*}
              <a href="/privacy"   rel="noreferrer" style={{paddingLeft:10, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                  Privacy Policy
                </Typography>
              </a>
              <a href="/orchideducation"   rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  &lArr; Orchid Education
                </Typography>
              </a>

              <a href="/orchidproblems"   rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  &lArr; Orchid Problems
                </Typography>
              </a>
              */}

              </div>

            </Grid>


          </Grid>
          <Dialog
              open={this.state.showOrderDialog}
              onClose={this.handleClickShowOrderDialogClose}
              scroll={'paper'}

              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
              maxWidth="md"
          >
            <DialogTitle id="scroll-dialog-title">Order Information</DialogTitle>
            <DialogContent id="farshids" style={{  justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >

              {/*} {(this.props.errorCMsg.status == 200) && (<div>
              The Operation was SUCCESSFUL!  Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
            </div>)}
            {(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
              The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
            </div>)}*/}
              <CreditCardForm></CreditCardForm>

            </DialogContent>
            <DialogActions>
              {/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
              <Button onClick={this.handleClickShowOrderDialogClose} color="secondary" style={{backgroundColor :'white',  border: '2px solid', color:'red', borderColor:'red', borderWidth:'2px', marginRight:20 }}>Cancel</Button>
              {/*<Button onClick={this.handleClickShowOrderDialogClose} color="secondary">Close</Button>*/}
            </DialogActions>
          </Dialog>
        </div>



    );
  }
}



AboutFloraPot.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,

    //auth:state.login.loginData,
    //CompanyDeleteResponse:state.account.deleteCompanyResp,
    //CompanySaveResponse:state.account.saveCompanyResp,
    //locationsArray:state.location.locationsArray,
    //vcArray:state.videocontroller.vcArray,
    //camerasArray:state.camera.camerasArray,
    //errorCMsg:state.account.errorCMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    //login:login,
    //handleAuthentication:handleAuthentication,
    //isAuthenticated:isAuthenticated,
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
    //updateAuth:updateAuth,

  }, dispatch);
};

//export default BiomassView;
//export default withStyles(styles)(AboutPlateWiz);




//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AboutFloraPot));
